import { APIError } from './APIError';

export class APITimeoutError extends APIError {
  constructor(...args: ConstructorParameters<typeof APIError>) {
    super(...args);

    // Set name explicitly as minification can mangle class names
    Object.defineProperty(this, 'name', { value: 'APITimeoutError' });
  }
}
